import createConcurrencyUrlStream from './Streams/createConcurrencyUrlStream';
import subscribeToConcurrencyUpdate from './Subscribers/subscribeToConcurrencyUpdate';
import subscribeToConsumerConfig from './Subscribers/subscribeToConsumerConfig';

const connectConfigSubscriptions = middleware => {
    const { config, concurrency } = middleware.state.stores;

    return [
        subscribeToConsumerConfig(middleware.consumerInput.config$, config),
        subscribeToConcurrencyUpdate(createConcurrencyUrlStream(concurrency.update$),config),
    ];
};

export default connectConfigSubscriptions;
